/* By Levane — cierre del selector de idioma.

   El desplegable es un <details> (ver snippets/bl-language-selector.liquid):
   abre, cierra y cambia de idioma sin una linea de JS. Esto solo le quita la
   unica aspereza del elemento nativo —quedarse abierto cuando el raton o el
   foco se van a otra parte— y anade Escape. Si el script no carga, el selector
   sigue funcionando entero.

   Hay hasta cuatro en la misma pagina (barra, menu movil y los dos pies), asi
   que el listener va en el documento y no uno por selector. */
(function () {
  function closeAll(except) {
    var open = document.querySelectorAll('details.bl-lang__dd[open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].removeAttribute('open');
    }
  }

  function owner(node) {
    return node && node.closest ? node.closest('details.bl-lang__dd') : null;
  }

  /* Al pulsar en un selector se deja abierto ese y se cierran los demas; al
     pulsar fuera, owner() es null y se cierran todos. */
  document.addEventListener('click', function (e) { closeAll(owner(e.target)); });
  document.addEventListener('focusin', function (e) { closeAll(owner(e.target)); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var open = document.querySelector('details.bl-lang__dd[open]');
    if (!open) return;
    open.removeAttribute('open');
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  });
})();
